import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { shortTestimonials, extendedTestimonials } from '../data/testimonials';
import { stats } from '../data/copy';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-172" data-mp="3grj6donkftrg">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-173" data-mp="3bq3kjudkdj80" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-174" data-mp="3lpuf1w24jy83">
        <h2 className="mb-10 text-center font-display text-xl font-bold tracking-[.14em] text-brand-light sm:text-2xl" data-id="element-175" data-mp="3lo02p64x5efm">📊 MADRES YA PREPARADAS</h2>
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10 sm:grid-cols-4" data-id="element-176" data-mp="3vgp4f9ao3dxr">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-177" data-mp="daas1es1rc1h">
              <p className="font-display text-4xl font-bold sm:text-5xl" data-id="element-178" data-mp="8bg7o8eflff9">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-179" data-mp="1gd4lu2f0imz9">{label}</p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-180" data-mp="1lc7qvmuzst78">
        <h2 className="mb-10 text-center font-display text-2xl font-bold sm:text-3xl" data-id="element-181" data-mp="1qasqpl6c1av5">💬 LO QUE DICEN LAS MADRES</h2>
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-182" data-mp="1udfd36k8i3ky">
          {shortTestimonials.map(({
          initials,
          name,
          place,
          quote
        }, index) => <Reveal as="article" key={name} delay={index * 80} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-183" data-mp="1z9wbctl5dybr" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-184" data-mp="291a6kp62gbz3">
                <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-185" data-mp="293we4osyirhb">{initials}</div>
                <div data-id="element-186" data-mp="2i3jd73y7rl77">
                  <h3 className="font-bold" data-id="element-187" data-mp="2i05bzz1adi1c">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-188" data-mp="2n0jobt9x7e56">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-189" data-mp="n03i9d67rhqj"><Stars data-id="element-190" data-mp="mzlc9otr1p5f" /></div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-191" data-mp="mwpdxzdzoygg">“{quote}”</p>
            </Reveal>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-192" data-mp="wqy7mqeraxg7">
      <div className="mx-auto max-w-5xl" data-id="element-193" data-mp="rwtxjya729aw">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-194" data-mp="16msuxytxdgpb">💬 LO QUE DICEN LAS MADRES</h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-195" data-mp="11n6frjujdqdv">
          {extendedTestimonials.map(({
          name,
          place,
          quote
        }) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-196" data-mp="1fn7h10epqztv">
              <Stars data-id="element-197" data-mp="1apph1ziobuy0" />
              <p className="mt-2 font-bold" data-id="element-198" data-mp="1ap5xyfhaf0ie">{name} <span className="font-normal text-slate-400" data-id="element-199" data-mp="3hf43v66bzw3y">· {place}</span></p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-200" data-mp="3hh6rjjk0hd5i">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}